import { identifyUser } from './identifyUser';
import { trackEvent } from './trackEvent';
import { TRACKING_EVENTS } from '@services/tracking/config';
import { UserInfo } from '@services/tracking/types';

export const trackAppOpen = (userInfo?: UserInfo): void => {
  if (userInfo?.emailAddress) {
    identifyUser(userInfo);
  }
  trackEvent(TRACKING_EVENTS.APP_OPENED);
};
